module.exports = {
  title: '康宝莱服务提供商发票审核系统',
  fixedHeader: true,
  sidebarLogo: true
}
